import { render, staticRenderFns } from "./ReactiveAvatar.vue?vue&type=template&id=111fbc12"
import script from "./ReactiveAvatar.vue?vue&type=script&lang=js"
export * from "./ReactiveAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports